type Props = {
    message?: string;
    variant?: "banner" | "overlay";
};

const PlacingSlipUploadStatus = ({
    message = "Uploading placing slip...",
    variant = "banner",
}: Props) => {
    if (variant === "overlay") {
        return (
            <div className="absolute inset-0 z-20 bg-white/80 backdrop-blur-[1px] flex items-center justify-center rounded-lg">
                <div className="flex flex-col items-center gap-3 px-6 py-5 bg-white rounded-xl shadow-lg border border-primary-100">
                    <div className="animate-spin rounded-full h-10 w-10 border-2 border-primary-500 border-t-transparent" />
                    <p className="text-sm font-semibold text-gray-800">
                        {message}
                    </p>
                    <p className="text-xs text-gray-500">
                        Please wait. Do not close this modal.
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="rounded-lg border border-primary-200 bg-primary-50 px-4 py-3">
            <div className="flex items-center gap-3">
                <div className="animate-spin rounded-full h-5 w-5 border-2 border-primary-500 border-t-transparent" />
                <p className="text-sm font-medium text-primary-700">
                    {message}
                </p>
            </div>
        </div>
    );
};

export default PlacingSlipUploadStatus;
